import { render, staticRenderFns } from "./LastxAlerts.vue?vue&type=template&id=b58ee58e&scoped=true"
import script from "./LastxAlerts.vue?vue&type=script&lang=js"
export * from "./LastxAlerts.vue?vue&type=script&lang=js"
import style0 from "./LastxAlerts.vue?vue&type=style&index=0&id=b58ee58e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b58ee58e",
  null
  
)

export default component.exports